var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeeExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 663,
    height: 622,
    viewBox: "0 0 663 622",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19188",
    "data-name": "Rectangle 19188",
    width: 663,
    height: 622,
    rx: 20,
    transform: "translate(142 2409)",
    fill: "#181818"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_18535",
    x: 50,
    y: -33,
    width: 586,
    height: 566,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.518
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5113",
    "data-name": "Ellipse 5113",
    cx: 36.137,
    cy: 36.137,
    r: 36.137,
    transform: "translate(0 0)",
    fill: "#363636"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Front-End_Developer_at_ACMEdev_Corp."
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "_02_24_-_Present"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_17546",
    x: 247,
    y: 100,
    width: 436,
    height: 472,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.518
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_17546-2",
    x: -71,
    y: 226,
    width: 436,
    height: 356,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.518
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Match"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "_96_"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "_91_"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Match-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_8",
    "data-name": "Mask Group 8",
    transform: "translate(-142 -2409)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48766",
    "data-name": "Group 48766"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47936",
    "data-name": "Group 47936",
    transform: "translate(176 1950)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -34, 459)",
    filter: "url(#Rectangle_18535)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18535-2",
    "data-name": "Rectangle 18535",
    width: 388,
    height: 368,
    rx: 30,
    transform: "translate(149 46)",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47922",
    "data-name": "Group 47922",
    transform: "translate(149.53 539.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47919",
    "data-name": "Group 47919",
    transform: "translate(0.207 -0.608)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51643",
    "data-name": "Path 51643",
    d: "M0,36.137A36.137,36.137,0,1,1,36.137,72.273,36.137,36.137,0,0,1,0,36.137",
    transform: "translate(0.883 0.726)",
    fill: "#03040a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51644",
    "data-name": "Path 51644",
    d: "M26.557,29.115s-1.151-6.363.182-10.815a5.935,5.935,0,0,1,3.993-3.975c.036-.011.706-4.457,9.85-4.792s16.394,3.557,14.615,19.6l-2.283,3.627L40.5,20.774s-10.638,6.881-11.576,10.15-2.365-1.81-2.365-1.81",
    transform: "translate(-4.024 -1.063)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51645",
    "data-name": "Path 51645",
    d: "M70.242,95.04H1.773A125.644,125.644,0,0,1,2.911,78.182C3.368,75.565,4,73.539,4.88,72.974a50.965,50.965,0,0,1,6.871-2.908c2.218-.831,4.694-1.7,7.012-2.51C23.6,65.87,27.8,64.491,27.8,64.491h16.41S48.5,65.9,53.393,67.6c.041.017.083.025.124.042,2.368.831,4.869,1.72,7.1,2.558a48.418,48.418,0,0,1,6.514,2.775c.988.623,1.661,3.074,2.118,6.131a131.4,131.4,0,0,1,1,15.936",
    transform: "translate(0.55 -11.401)",
    fill: "#f5a784"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51646",
    "data-name": "Path 51646",
    d: "M50.239,62.088l-7.709,1.3V63.6l-.641-.1-.628.1v-.214l-7.431-1.3.4-3.245.88-7.13H48.68l.754,5.055Z",
    transform: "translate(-5.478 -8.998)",
    fill: "#f5a784"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51647",
    "data-name": "Path 51647",
    d: "M49.527,56.769a29.218,29.218,0,0,1-15.2,2.075l.88-7.13H48.773Z",
    transform: "translate(-5.571 -8.998)",
    fill: "#e0855c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51648",
    "data-name": "Path 51648",
    d: "M58.329,36.653s1.131-4.475,3.945-2.491,0,8.522-3.966,8.487c0,0-1.058-4.386.02-6",
    transform: "translate(-9.994 -5.602)",
    fill: "#f5a784"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51649",
    "data-name": "Path 51649",
    d: "M61.543,36.847a3.63,3.63,0,0,0-1.437,1.19,4.387,4.387,0,0,0-.975,1.581c-.047.181.207.261.312.137.3-.345.52-.745.791-1.112a2.049,2.049,0,0,0,.818.507c.244.059.386-.253.261-.434a1.848,1.848,0,0,0-.686-.522,9.588,9.588,0,0,0,1.128-1.064.184.184,0,0,0-.21-.283",
    transform: "translate(-10.235 -6.201)",
    fill: "#e0855c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51650",
    "data-name": "Path 51650",
    d: "M28.319,36.132s-1.131-4.475-3.945-2.491,0,8.522,3.966,8.487c0,0,1.058-4.386-.02-6",
    transform: "translate(-3.486 -5.504)",
    fill: "#f5a784"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51651",
    "data-name": "Path 51651",
    d: "M25.776,36.326a3.629,3.629,0,0,1,1.437,1.19,4.387,4.387,0,0,1,.975,1.581c.047.181-.207.261-.312.137-.3-.345-.52-.745-.791-1.112a2.052,2.052,0,0,1-.817.507c-.245.059-.386-.253-.261-.434a1.848,1.848,0,0,1,.686-.522,9.587,9.587,0,0,1-1.128-1.064.184.184,0,0,1,.21-.283",
    transform: "translate(-3.917 -6.103)",
    fill: "#e0855c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51652",
    "data-name": "Path 51652",
    d: "M53.3,27.735C50.663,15.069,40.949,15.957,40.949,15.957s-9.714-.888-12.355,11.778a24.287,24.287,0,0,0,1.129,14.1c1.713,4.21,5,8.744,11.225,8.744s9.513-4.534,11.225-8.744a24.28,24.28,0,0,0,1.129-14.1",
    transform: "translate(-4.39 -2.272)",
    fill: "#f5a784"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51653",
    "data-name": "Path 51653",
    d: "M44.147,40.719c-.568-.056-1.845.345-2.14-.251-.246-.5.512-3.534.615-4.054a50.7,50.7,0,0,0,1.033-5.387.106.106,0,0,0-.2-.044c-1.159,3.012-1.465,6.684-2.1,9.854a.28.28,0,0,0,.284.338c.827-.054,1.639.08,2.464.044.275-.012.334-.471.042-.5",
    transform: "translate(-6.893 -5.089)",
    fill: "#e0855c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51654",
    "data-name": "Path 51654",
    d: "M37.088,35.26s-1.068.4-.906-1.493c.146-1.7.906-1.47.906-1.47s.742,0,.63,1.482-.63,1.482-.63,1.482",
    transform: "translate(-5.917 -5.345)",
    fill: "#3b2645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51655",
    "data-name": "Path 51655",
    d: "M49.641,35.26s-1.068.4-.906-1.493c.146-1.7.906-1.47.906-1.47s.742,0,.63,1.482-.63,1.482-.63,1.482",
    transform: "translate(-8.278 -5.345)",
    fill: "#3b2645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51656",
    "data-name": "Path 51656",
    d: "M38.294,29c-.918-.468-2.634-.592-3.3.363a.285.285,0,0,0,.244.426c.456-.024.859-.244,1.316-.283a3.71,3.71,0,0,1,1.435.221A.4.4,0,0,0,38.294,29",
    transform: "translate(-5.689 -4.66)",
    fill: "#3b2645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51657",
    "data-name": "Path 51657",
    d: "M50.847,29c-.918-.468-2.634-.592-3.3.363a.285.285,0,0,0,.244.426c.456-.024.859-.244,1.316-.283a3.71,3.71,0,0,1,1.435.221A.4.4,0,0,0,50.847,29",
    transform: "translate(-8.049 -4.66)",
    fill: "#3b2645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51658",
    "data-name": "Path 51658",
    d: "M34.915,17.949s5.788,1.181,9.731-1,10.588,9.038,10.4,13.705l1.24-5.317L50.35,14.1l-11.283-.839s-5.243,2.838-4.152,4.691",
    transform: "translate(-5.654 -1.767)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51659",
    "data-name": "Path 51659",
    d: "M33.392,18.994a33.318,33.318,0,0,0-5.5,12.265L26.665,29.11s2.009-11.863,6.727-10.115",
    transform: "translate(-4.131 -2.813)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51660",
    "data-name": "Path 51660",
    d: "M69.509,79.815C64.7,84.833,59.414,90.657,59.356,95.75H13.627c-.075-6.14-5.9-12.163-10.452-16.858.456-2.617,1.088-4.644,1.969-5.209a50.943,50.943,0,0,1,6.871-2.908c2.218-.831,4.694-1.7,7.012-2.509C22.6,79.648,33.542,80.056,36.192,79.989c0-.033.116-.025.3-.017.183-.008.291-.016.291-.016,2.584.1,13.035-1.08,16.874-11.648.041.017.083.025.124.041,2.368.831,4.869,1.72,7.095,2.559a48.4,48.4,0,0,1,6.514,2.775c.988.623,1.661,3.073,2.118,6.131",
    transform: "translate(0.286 -12.11)",
    fill: "#308dbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51661",
    "data-name": "Path 51661",
    d: "M45.843,46.12A5.1,5.1,0,0,1,43.565,47.6,6.611,6.611,0,0,1,40.84,47.4a.105.105,0,0,0-.1.174c1.375,1.705,4.845.683,5.581-1.179.112-.283-.287-.454-.477-.278",
    transform: "translate(-6.772 -7.933)",
    fill: "#e0855c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51662",
    "data-name": "Path 51662",
    d: "M36.194,37.1c-.122,0-.247,0-.377-.011-2.257-.127-3.569-1.491-3.789-3.942a1.455,1.455,0,0,1,1.452-1.585h5.142a1.469,1.469,0,0,1,1.083.478,1.44,1.44,0,0,1,.369,1.1c-.093,1-.374,3.959-3.88,3.959m-2.714-4.929a.847.847,0,0,0-.846.922c.193,2.139,1.276,3.279,3.219,3.388,2.911.165,3.459-1.729,3.616-3.4a.82.82,0,0,0-.214-.633.859.859,0,0,0-.633-.279Z",
    transform: "translate(-5.138 -5.208)",
    fill: "#3b2645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51663",
    "data-name": "Path 51663",
    d: "M48.4,37.1c-.122,0-.247,0-.377-.011-2.256-.127-3.568-1.491-3.789-3.942a1.455,1.455,0,0,1,1.452-1.585h5.141a1.467,1.467,0,0,1,1.084.479,1.433,1.433,0,0,1,.369,1.1c-.093,1-.374,3.958-3.88,3.958m-2.714-4.929a.847.847,0,0,0-.846.922c.193,2.139,1.276,3.279,3.218,3.388,2.9.171,3.459-1.729,3.616-3.4a.816.816,0,0,0-.214-.633.859.859,0,0,0-.633-.279Z",
    transform: "translate(-7.433 -5.208)",
    fill: "#3b2645"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18533",
    "data-name": "Rectangle 18533",
    width: 2.628,
    height: 0.609,
    transform: "translate(34.653 27.289)",
    fill: "#3b2645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51664",
    "data-name": "Path 51664",
    d: "M32.468,10.774a13.888,13.888,0,0,1,5-2.707C41.176,6.962,54.419,7.9,56.061,6.478c1.239,4.363-1.785,6.292-5.316,9.137-3.891,3.134-9.422,3.442-14.289,2.312a10.251,10.251,0,0,0-2.615-.413,7.664,7.664,0,0,1-2.087.042c-3.3-.821-.719-5.568.714-6.782",
    transform: "translate(-4.786 -0.492)",
    fill: "#363636"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Alex_Wilson",
    "data-name": "Alex Wilson",
    transform: "translate(242.5 555.585)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Alex Wilson")), /*#__PURE__*/React.createElement("text", {
    id: "San_Jose_CA_United_States",
    "data-name": "San Jose, CA United States",
    transform: "translate(259.532 581.97)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Helvetica",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "San Jose, CA United States")), /*#__PURE__*/React.createElement("g", {
    id: "path",
    transform: "translate(242.5 570.542)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    "data-name": "path",
    d: "M8.367,2.5c2.636,0,4.985,2.177,4.87,4.584-.115,2.636-3.552,8.022-4.87,8.022S3.612,9.777,3.5,7.084C3.382,4.677,5.732,2.5,8.367,2.5Zm0,11.4.516-.516a19.02,19.02,0,0,0,1.375-1.834,10.486,10.486,0,0,0,1.834-4.469A3.669,3.669,0,0,0,8.367,3.646,3.669,3.669,0,0,0,4.643,7.084a10.217,10.217,0,0,0,1.834,4.469,12.713,12.713,0,0,0,1.375,1.834,2.188,2.188,0,0,0,.516.516Zm0-4.526A2.005,2.005,0,1,1,10.373,7.37,2.03,2.03,0,0,1,8.367,9.376Zm0-1.146a.859.859,0,1,0-.859-.859.881.881,0,0,0,.859.859Z",
    transform: "translate(-3.493 -2.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-email",
    "data-name": "Icon material-email",
    d: "M14.964,6H4.329A1.328,1.328,0,0,0,3.007,7.329L3,15.305a1.333,1.333,0,0,0,1.329,1.329H14.964a1.333,1.333,0,0,0,1.329-1.329V7.329A1.333,1.333,0,0,0,14.964,6Zm0,2.659L9.647,11.982,4.329,8.659V7.329l5.317,3.323,5.317-3.323Z",
    transform: "translate(239.5 590.01)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("text", {
    id: "AlexWilson.Dev_gmail.com",
    "data-name": "AlexWilson.Dev@gmail.com",
    transform: "translate(262.442 607.535)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Helvetica",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "AlexWilson.Dev@gmail.com")), /*#__PURE__*/React.createElement("text", {
    id: "Work_Experience",
    "data-name": "Work Experience",
    transform: "translate(149.737 638.882)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Work Experience")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17693",
    "data-name": "Rectangle 17693",
    width: 316,
    height: 63,
    transform: "translate(150 651.882)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Front-End_Developer_at_ACMEdev_Corp.-2",
    "data-name": "Front-End Developer at ACMEdev Corp.",
    transform: "translate(165 678.882)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Front-End Developer at ACMEdev Corp.")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -34, 459)",
    filter: "url(#Front-End_Developer_at_ACMEdev_Corp.)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Front-End_Developer_at_ACMEdev_Corp.-3",
    "data-name": "Front-End Developer at ACMEdev Corp.",
    transform: "translate(199 219.88)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Front-End Developer at ACMEdev Corp.")))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_02_24_-_Present-2",
    "data-name": "02/24 - Present",
    transform: "translate(165 700.882)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "Helvetica",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "02/24 - Present")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -34, 459)",
    filter: "url(#_02_24_-_Present)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_02_24_-_Present-3",
    "data-name": "02/24 - Present",
    transform: "translate(199 241.88)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "Helvetica",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "02/24 - Present")))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-pencil",
    "data-name": "Icon open-pencil",
    d: "M9.128,0,7.606,1.521l3.043,3.043L12.17,3.043ZM6.085,3.043,0,9.128V12.17H3.043L9.128,6.085Z",
    transform: "translate(439.49 670.797)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Skills",
    transform: "translate(149.737 743.5)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Skills")), /*#__PURE__*/React.createElement("g", {
    id: "Group_48283",
    "data-name": "Group 48283",
    transform: "translate(-92 337.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46794",
    "data-name": "Group 46794",
    transform: "translate(238 420.107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_15104",
    "data-name": "Rectangle 15104",
    transform: "translate(4 1)",
    fill: "#363636",
    stroke: "rgba(61,182,251,0.25)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119,
    height: 24,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 118,
    height: 23,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Front-End_Frameworks",
    "data-name": "Front-End Frameworks",
    transform: "translate(14 16)",
    fill: "#3db6fb",
    fontSize: 9.1,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Front-End Frameworks"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46795",
    "data-name": "Group 46795",
    transform: "translate(362 420.107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_15104-2",
    "data-name": "Rectangle 15104",
    transform: "translate(4 1)",
    fill: "#363636",
    stroke: "rgba(61,182,251,0.25)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 24,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 103,
    height: 23,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Responsive_Design",
    "data-name": "Responsive Design",
    transform: "translate(14 16)",
    fill: "#3db6fb",
    fontSize: 10,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Responsive Design"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46796",
    "data-name": "Group 46796",
    transform: "translate(341 449.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_15104-3",
    "data-name": "Rectangle 15104",
    transform: "translate(4 1)",
    fill: "#363636",
    stroke: "rgba(61,182,251,0.25)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 125,
    height: 24,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 124,
    height: 23,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_Database_Management",
    "data-name": " Database Management",
    transform: "translate(14 16)",
    fill: "#3db6fb",
    fontSize: 10,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, " Database Management"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46797",
    "data-name": "Group 46797",
    transform: "translate(238 449.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_15104-4",
    "data-name": "Rectangle 15104",
    transform: "translate(4 1)",
    fill: "#363636",
    stroke: "rgba(61,182,251,0.25)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 24,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 97,
    height: 23,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Security_Practices",
    "data-name": "Security Practices",
    transform: "translate(14 16)",
    fill: "#3db6fb",
    fontSize: 10,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Security Practices"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46798",
    "data-name": "Group 46798",
    transform: "translate(238 478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_15104-5",
    "data-name": "Rectangle 15104",
    transform: "translate(4 1)",
    fill: "#363636",
    stroke: "rgba(61,182,251,0.25)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 24,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 23,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SEO_Basics",
    "data-name": "SEO Basics",
    transform: "translate(14 16)",
    fill: "#3db6fb",
    fontSize: 10,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SEO Basics"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46799",
    "data-name": "Group 46799",
    transform: "translate(312 478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_15104-6",
    "data-name": "Rectangle 15104",
    transform: "translate(4 1)",
    fill: "#363636",
    stroke: "rgba(61,182,251,0.25)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 24,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 98,
    height: 23,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Strategic_Thinking",
    "data-name": "Strategic Thinking",
    transform: "translate(14 16)",
    fill: "#3db6fb",
    fontSize: 9.1,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Strategic Thinking")))))), /*#__PURE__*/React.createElement("rect", {
    id: "Image_578",
    "data-name": "Image 578",
    width: 322,
    height: 96,
    transform: "translate(317 2407)",
    fill: "url(#pattern)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48289",
    "data-name": "Group 48289",
    transform: "translate(6813 16432)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -6671, -14023)",
    filter: "url(#Rectangle_17546)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17546-3",
    "data-name": "Rectangle 17546",
    width: 238,
    height: 274,
    rx: 20,
    transform: "translate(366 199)",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Pathways",
    transform: "translate(-6284 -13795)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Pathways")), /*#__PURE__*/React.createElement("g", {
    id: "Group_48290",
    "data-name": "Group 48290",
    transform: "translate(-7299 -14705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22337",
    className: "web-dev-arrow",
    "data-name": "Group 22337",
    transform: "translate(1111.458 981.74)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_656",
    "data-name": "Line 656",
    y2: 16.339,
    transform: "translate(3.067 0)",
    fill: "none",
    stroke: "#469dcc",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M2.861,0,5.722,6.54H0Z",
    transform: "translate(5.722 19.21) rotate(180)",
    fill: "#3db6fb"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path-web-dev"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14054",
    "data-name": "Rectangle 14054",
    width: 197.646,
    height: 54.769,
    transform: "translate(1015 927)",
    fill: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Web_Developer",
    "data-name": "Web Developer",
    transform: "translate(1111 950)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -46.843,
    y: 10
  }, "Web Developer"))), /*#__PURE__*/React.createElement("g", {
    className: "path-senior-dev"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14050",
    "data-name": "Rectangle 14050",
    width: 197.646,
    height: 54.769,
    transform: "translate(1015 1002.205)",
    fill: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Senior_Web_Developer",
    "data-name": "Senior Web Developer",
    transform: "translate(1111 1025)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -68.875,
    y: 10
  }, "Senior Web Developer"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22338",
    className: "web-senior-arrow",
    "data-name": "Group 22338",
    transform: "translate(1111.458 1057.354)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_656-2",
    "data-name": "Line 656",
    y2: 16.339,
    transform: "translate(3.067 0)",
    fill: "none",
    stroke: "#7a849c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-2",
    "data-name": "Polygon 1",
    d: "M2.861,0,5.722,6.54H0Z",
    transform: "translate(5.722 19.21) rotate(180)",
    fill: "#3db6fb"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path-full-dev"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46295",
    "data-name": "Path 46295",
    d: "M0,0H197.646V54.769H0Z",
    transform: "translate(1015 1075.775)",
    fill: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Full-Stack_Developer",
    "data-name": "Full-Stack Developer",
    transform: "translate(1111 1096)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -64.299,
    y: 10
  }, "Full-Stack Developer")))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48288",
    "data-name": "Group 48288",
    transform: "translate(6495 16558)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -6353, -14149)",
    filter: "url(#Rectangle_17546-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17546-4",
    "data-name": "Rectangle 17546",
    width: 238,
    height: 158,
    rx: 20,
    transform: "translate(48 325)",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Front-End_Web_Developer",
    "data-name": "Front-End Web Developer",
    transform: "translate(-6236.5 -13761.014)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Front-End Web Developer")), /*#__PURE__*/React.createElement("text", {
    id: "Mobile_Web_Developer",
    "data-name": "Mobile Web Developer",
    transform: "translate(-6236.5 -13708.282)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Mobile Web Developer")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17695",
    "data-name": "Rectangle 17695",
    width: 35,
    height: 35,
    rx: 8,
    transform: "translate(-6284 -13773)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17696",
    "data-name": "Rectangle 17696",
    width: 35,
    height: 35,
    rx: 8,
    transform: "translate(-6284 -13720)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-code",
    "data-name": "Icon ionic-ios-code",
    transform: "translate(-6277.156 -13761.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46296",
    "data-name": "Path 46296",
    d: "M22.963,10.007a.338.338,0,0,0-.223-.092.327.327,0,0,0-.223.092l-.751.718a.316.316,0,0,0,0,.468l5.21,4.977-5.21,4.977a.316.316,0,0,0,0,.468l.751.718a.327.327,0,0,0,.223.092.317.317,0,0,0,.223-.092L29.174,16.4a.316.316,0,0,0,0-.468Z",
    transform: "translate(-8.387 -9.914)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46297",
    "data-name": "Path 46297",
    d: "M12.114,10.958a.322.322,0,0,0-.1-.234l-.751-.718a.338.338,0,0,0-.223-.092.327.327,0,0,0-.223.092L4.6,15.935a.316.316,0,0,0,0,.468l6.211,5.928a.337.337,0,0,0,.223.092.317.317,0,0,0,.223-.092l.751-.718a.316.316,0,0,0,0-.468L6.8,16.169l5.21-4.977A.322.322,0,0,0,12.114,10.958Z",
    transform: "translate(-4.5 -9.914)",
    fill: "#3db6fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-code-2",
    "data-name": "Icon ionic-ios-code",
    transform: "translate(-6277.156 -13709.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46296-2",
    "data-name": "Path 46296",
    d: "M22.963,10.007a.338.338,0,0,0-.223-.092.327.327,0,0,0-.223.092l-.751.718a.316.316,0,0,0,0,.468l5.21,4.977-5.21,4.977a.316.316,0,0,0,0,.468l.751.718a.327.327,0,0,0,.223.092.317.317,0,0,0,.223-.092L29.174,16.4a.316.316,0,0,0,0-.468Z",
    transform: "translate(-8.387 -9.914)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46297-2",
    "data-name": "Path 46297",
    d: "M12.114,10.958a.322.322,0,0,0-.1-.234l-.751-.718a.338.338,0,0,0-.223-.092.327.327,0,0,0-.223.092L4.6,15.935a.316.316,0,0,0,0,.468l6.211,5.928a.337.337,0,0,0,.223.092.317.317,0,0,0,.223-.092l.751-.718a.316.316,0,0,0,0-.468L6.8,16.169l5.21-4.977A.322.322,0,0,0,12.114,10.958Z",
    transform: "translate(-4.5 -9.914)",
    fill: "#3db6fb"
  })), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Match-3",
    "data-name": "Match",
    transform: "translate(-6236.157 -13743.449)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "Helvetica",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Match")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -6353, -14149)",
    filter: "url(#Match)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Match-4",
    "data-name": "Match",
    transform: "translate(116.84 405.55)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "Helvetica",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Match")))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_96_2",
    "data-name": "96%",
    transform: "translate(-6105.157 -13743.449)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "96%")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -6353, -14149)",
    filter: "url(#_96_)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_96_3",
    "data-name": "96%",
    transform: "translate(247.84 405.55)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "96%")))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_91_2",
    "data-name": "91%",
    transform: "translate(-6103.657 -13690.718)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "91%")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -6353, -14149)",
    filter: "url(#_91_)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_91_3",
    "data-name": "91%",
    transform: "translate(249.34 458.28)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "91%")))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Match-5",
    "data-name": "Match",
    transform: "translate(-6236.157 -13690.717)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "Helvetica",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Match")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -6353, -14149)",
    filter: "url(#Match-2)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Match-6",
    "data-name": "Match",
    transform: "translate(116.84 458.28)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "Helvetica",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Match")))), /*#__PURE__*/React.createElement("text", {
    id: "Job_Recommendations",
    "data-name": "Job Recommendations",
    transform: "translate(-6284 -13795)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Job Recommendations")), /*#__PURE__*/React.createElement("g", {
    id: "Group_48286",
    "data-name": "Group 48286",
    transform: "translate(-6194.313 -13746.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44983",
    "data-name": "Group 44983",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44298",
    "data-name": "Group 44298"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1261",
    "data-name": "Line 1261",
    x2: 82.455,
    fill: "none",
    stroke: "#7a849c",
    strokeLinecap: "round",
    strokeWidth: 5,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1264",
    "data-name": "Line 1264",
    x2: 78.332,
    fill: "none",
    stroke: "#0d5ada",
    strokeLinecap: "round",
    strokeWidth: 5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48287",
    "data-name": "Group 48287",
    transform: "translate(-6194.313 -13694.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44984",
    "data-name": "Group 44984",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1283",
    "data-name": "Line 1283",
    x2: 82.455,
    fill: "none",
    stroke: "#7a849c",
    strokeLinecap: "round",
    strokeWidth: 5,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1284",
    "data-name": "Line 1284",
    x2: 74.209,
    fill: "none",
    stroke: "#3e9cfb",
    strokeLinecap: "round",
    strokeWidth: 5
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_2124",
    "data-name": "Line 2124",
    x2: 199,
    transform: "translate(-6283.5 -13728.5)",
    fill: "none",
    stroke: "#78849e",
    strokeWidth: 1,
    opacity: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeExperience);
export default __webpack_public_path__ + "static/media/employee-experience.bdfde789217e3b208a880ed74cd35ed1.svg";
export { ForwardRef as ReactComponent };